import { SaleEditConfiguration } from "./sale-edit.routes";
import { SummaryController } from "./summary.controller";
import { MissingFieldController } from "./missing-field.controller";

import { SaleEditModel } from "./sale-edit.model";
import { V2_STATES_REDIRECT } from "../../thor.const";

import "./add-item/add-item.component";
import "./live/live-sale-summary.component";

class SaleEditStateChange {
    public static $inject: string[] = [
        "$location",
        "$log",
        "$rootScope",
        "$state",
        "aclService",
        "toaster",
        "$translate",
        "$window"
    ];

    constructor(
        $location,
        $log: ng.ILogService,
        $rootScope: ng.IRootScopeService,
        $state: ng.ui.IStateService,
        aclService,
        toaster,
        $translate: ng.translate.ITranslateService,
        $window: ng.IWindowService
    ) {
         // Redirect to lower case url for users trying to access page with capital letters
         let currentUrl = $location.path();

         if (/[A-Z]/.test(currentUrl)) {
            $location.path(currentUrl.toLowerCase());
         }

        /**
         * custom ui-router $stateChangeError callback
         * @param {Object} event
         * @param {Object} error
         */
        $rootScope.$on("stateChangeError", (event, error) => {
            event.preventDefault();
            $log.error("stateChangeError event", error);

            let message = "une_erreur_est_survenue";

            switch (error && error.status) {
                case 401:
                    message = "impossible_d_acceder_a_la_ressource";
                    break;
                case 403:
                    message = "acces_non_autorise";
                    break;
                case 404:
                    message = "page_introuvable";
                    break;
                default: break;
            }
            toaster.show($translate.instant(message), true);

            const stateName = aclService.getDefaultState();

            V2_STATES_REDIRECT.forEach(state => {
                if (state.name === stateName) {
                    return $window.location.href = state.url;
                }
            });

            $state.go(stateName);
        });
    }
}

angular
    .module("thor.sale-edit", ["thor.sales.edit.add-item.component", "thor.sales.edit.live-sale-summary.component"])
    .config(SaleEditConfiguration)
    .service("saleEditModel", SaleEditModel)
    .controller("SummaryController", SummaryController)
    .controller("MissingFieldController", MissingFieldController)
    .run(SaleEditStateChange);
